import { Component, EventEmitter, Output } from '@angular/core';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-my-organization-delete',
  templateUrl: './my-organization-delete.component.html',
  styleUrls: ['./my-organization-delete.component.css'],
})
export class MyOrganizationDeleteComponent {
  headerData: any;
  headerName = '';
  @Output() deleteManage = new EventEmitter<any>();

  constructor(private modal: CustomModalService) {}

  ngOnInit(): void {
    this.headerData = this.modal?.modalService?.config?.initialState?.['headerName'];
    switch (this.headerData) {
      case 'manageUsers':
      case 'AdminManageUsers':
        this.headerName = 'Delete confirmation for user';
        break;
      case 'manageTeams':
      case 'AdminForManageTeams':
        this.headerName = 'Delete confirmation for team';
        break;
      case 'manageScenarioWorkFlow':
        this.headerName = 'Delete confirmation for scenario status';
        break;
      case 'manageProductGroups':
        this.headerName = 'Delete confirmation for product group';
        break;
      case 'manageProjectWorkflow':
        this.headerName = 'Delete confirmation for project status';
        break;
      case 'projectSavingLogs':
        this.headerName = 'Delete confirmation for project saving log';
        break;
      case 'organizationYearEndOn':
        this.headerName = 'Delete confirmation for Organization Year End';
        break;
      case 'listOfSuppliers':
        this.headerName = 'Delete confirmation for Supplier';
        break;
      case 'customCategory':
        this.headerName = 'Delete confirmation for custom category';
        break;
      case 'customPackagingMaterial':
        this.headerName = 'Delete confirmation for custom packaging metrics';
        break;
      case 'ssoGroup':
        this.headerName = 'Delete confirmation for SSO Group';
        break;
      case 'organizationMember':
        this.headerName = 'Delete confirmation for Organization Membership';
        break;
      case 'manageTeams/details/:id':
      case 'Team Membership':
        this.headerName = 'Delete Team Membership';
        break;
      case 'manageUsers/details/:id':
        this.headerName = 'Delete organization Membership';
        break;
      case 'organizationPreferences':
        this.headerName = 'Delete confirmation for Organization Preferences';
        break;
      default:
        break;
    }
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.deleteManage.emit();
    this.onClose();
  }
}
